import React from 'react';
import {BaseInputProps} from '../..';

import {Tooltip} from '@mantine/core';
import {ErrorOption, useController, useFormContext} from 'react-hook-form';
import {RiInformationFill} from 'react-icons/ri';
import {NestedKeys} from 'shared/types/key-manipulation';
import {Container, ContainerLabel, Label, Input as StyledInput} from './styles';
import ErrorWrapper from '../error-wrapper';

export type NumberInputProps<T = any> = BaseInputProps & {
  name: NestedKeys<T>;
  gridColumn?: number;
};

const NumberInput: React.FC<NumberInputProps> = ({
  name,
  label,
  gridColumn,
  border,
  information,
  hidden,
  required,
  ...props
}) => {
  const {control, setValue, clearErrors, formState} = useFormContext();
  const {field} = useController({control, name: name!});

  const error: ErrorOption | undefined = formState.errors
    ? formState.errors[name as string]
    : undefined;

  return (
    <ErrorWrapper {...{error: error?.message, gridColumn}}>
      <Container {...{gridColumn, border, error}}>
        <ContainerLabel>
          {label && (
            <Label {...{error: !!error}}>
              {label}
              {required && ' *'}
            </Label>
          )}
          {information && (
            <Tooltip
              label={information}
              multiline
              withArrow
              arrowSize={10}
              openDelay={500}
              w={200}
              position="top">
              <div>
                <RiInformationFill size={20} />
              </div>
            </Tooltip>
          )}
        </ContainerLabel>
        <StyledInput
          {...{
            ...props,
            onChange: (e) => {
              clearErrors(name);
              field.onChange(+e.target.value);
            },
            type: 'number',
            value: field.value,
            error: !!error,
          }}
        />
      </Container>
    </ErrorWrapper>
  );
};

export default NumberInput;
